import React, { useContext } from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import { Field } from 'react-final-form'
import { formulaireChangementAppartementEnum } from '../enums/formulaireChangementAppartementEnum'
import FormNumberFormatField from '../../../components/fields/FormNumberFormatField'
import { formTypeEnum } from '../../../components/fields/enum/formTypeEnum'
import { FormattedMessage, useIntl } from 'react-intl'
import styles from '../../../styles'
import { Theme } from '@material-ui/core/styles/createMuiTheme'
import { ResponsiveContext } from '../../../utils/context/responsiveContext'

const useStyles = makeStyles<Theme, { isLargeScreen: boolean }>(
	(theme) => (
		{
			conteneurChamp: {
				marginTop: props => props.isLargeScreen ? 0 : 40
			},
			titleStyle: {
				...styles(theme).title6,
				fontSize: 28,
				margin: props => `${props.isLargeScreen ? 30 : 40}px 0 15px 0`,
				color: theme.palette.blue.main
			}
		}
	)
)

const DimensionVehicule = () => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const classes = useStyles({ isLargeScreen })
	const intl = useIntl()

	return (
		<Grid container item xs={12} spacing={2}>
			<Grid item xs={12}>
				<h1 className={classes.titleStyle}>
					<FormattedMessage
						id="changementAppartement.formulaire.dimensionVehicule.title"
						defaultMessage="Dimensions du véhicule"
						description="Search reason title"
					/>
				</h1>
			</Grid>

			{/*	Champ pour la longueur du véhicule */}
			<Grid item xs={12} md={6}>
				<Field
					name={formulaireChangementAppartementEnum.longueur}
					component={FormNumberFormatField}
					label={`${intl.formatMessage({
						id: 'changementAppartement.formulaire.longueur.label',
						defaultMessage: 'Longueur en mm',
						description: 'Label du champ sur la longueur du véhicule'
					})} *`}
					allowNegative={false}
					decimalScale={0}
					formType={formTypeEnum.textFieldInline}
					maxLength={4}
				/>
			</Grid>

			{/*	Champ pour la largeur du véhicule */}
			<Grid item xs={12} md={6} className={classes.conteneurChamp}>
				<Field
					name={formulaireChangementAppartementEnum.largeur}
					component={FormNumberFormatField}
					label={`${intl.formatMessage({
						id: 'changementAppartement.formulaire.largeur.label',
						defaultMessage: 'Largeur en mm',
						description: 'Label du champ sur la largeur du véhicule'
					})} *`}
					allowNegative={false}
					decimalScale={0}
					formType={formTypeEnum.textFieldInline}
					maxLength={4}
				/>
			</Grid>

			{/*	Champ pour la hauteur du véhicule */}
			<Grid item xs={12} md={6} className={classes.conteneurChamp}>
				<Field
					name={formulaireChangementAppartementEnum.hauteur}
					component={FormNumberFormatField}
					label={`${intl.formatMessage({
						id: 'changementAppartement.formulaire.hauteur.label',
						defaultMessage: 'Hauteur en mm',
						description: 'Label du champ sur la hauteur du véhicule'
					})} *`}
					allowNegative={false}
					decimalScale={0}
					formType={formTypeEnum.textFieldInline}
					maxLength={4}
				/>
			</Grid>
		</Grid>
	)
}

export default DimensionVehicule
